module.exports = __webpack_public_path__ + "img/call_frame.2f04e502.png";